import { useState, useEffect } from 'react';
import { usePlatStageContext } from '@mono/use-plat-stage';
import { toHash } from '@mono/to-hash';

const cdsEndpoints = {
    test: 'https://b34lyymv0m.execute-api.us-east-1.amazonaws.com/test',
    acceptance: 'https://2m32ikg0jh.execute-api.us-east-1.amazonaws.com/acceptance',
    prod: 'https://jcmvnzpx98.execute-api.us-east-1.amazonaws.com/prod',
};

interface useCdsTafProps {
    loadIcaoIds?: string[];
    updateInterval?: number;
}
export const useCdsTaf = ({ loadIcaoIds = [], updateInterval = 5 * 60 * 1000 }: useCdsTafProps) => {
    const { stage } = usePlatStageContext();
    const [icaoIds, setIcaoIds] = useState<string[]>([]);
    const [isLoadingIcaoIds, setIsLoadingIcaoIds] = useState<boolean>(false);
    const [data, setData] = useState<{
        [icaoId: string]: CdsTafResponseData;
    }>({});

    const [forceUpdate, setForceUpdate] = useState<string>();

    const headers: { Authorization: string } | {} = localStorage.metjwt ? { Authorization: 'Bearer ' + localStorage.metjwt } : {};

    useEffect(() => {
        if (!updateInterval) return;

        const interval = setInterval(() => {
            setForceUpdate(Date.now().toString());
        }, updateInterval);

        return () => {
            clearInterval(interval);
        };
    }, [updateInterval]);

    useEffect(() => {
        (async () => {
            setIsLoadingIcaoIds(true);

            const rawResponse = await fetch(cdsEndpoints[stage] + '/v0/platforms-product-store-cache/list', { headers });

            const response = await rawResponse.json();

            setIcaoIds(response.icaoIds);
            setIsLoadingIcaoIds(false);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            for (const icaoId of loadIcaoIds) {
                const rawResponse = await fetch(cdsEndpoints[stage] + '/v0/platforms-product-store-cache?icaoId=' + icaoId, { headers });
                const response = await rawResponse.json();
                const responseData = response.data as CdsTafResponseData;
                setData((prevData) => ({
                    ...prevData,
                    [icaoId]: responseData,
                }));
            }
        })();
    }, [toHash(loadIcaoIds), forceUpdate]);

    return {
        icaoIds,
        isLoadingIcaoIds,
        data,
    };
};

export interface CdsTafResponseData {
    [time: string]: {
        CloudBaseFt: string;
        CloudCoverOktas: string;
        VisibilityM: string;
        WindSpeedKt: string;
        CrossWindKt: string;
        LightningPerc: string;
        WindGustKt: string;
        dataSource: 'METAR' | 'TAF' | 'MODEL';
    };
}
